<template>
  <div class="col-12">
    <div
      class="form-group"
      v-if="(!$login.getUser().analyst && !$login.channelScopeId()) || this.isAnEditor"
    >
      <label>Channel</label>
      <multiselect
        :options="channels"
        :allow-empty="false"
        :searchable="true"
        :show-labels="false"
        placeholder="Select a channel..."
        track-by="id"
        :custom-label="({name}) => name"
        :value="article.channel"
        @input="(channel) => $emit('update', {channel, channel_content_type: {channel}})"
      />
    </div>

    <div v-if="this.article.channel" class="form-group">
      <label>Content Type</label>
      <multiselect
        :options="contentTypes"
        :allow-empty="false"
        :searchable="true"
        :show-labels="false"
        :class="{
          'is-invalid': highlightFields && !contentType
        }"
        placeholder="Select a content type"
        track-by="id"
        v-model="contentType"
        :custom-label="({content_type}) => content_type.name"
        @input="updateContentType"
      >
        <span
          slot="singleLabel"
          slot-scope="prop"
        >
          {{ prop.option.content_type.name }}
        </span>
        <span
          slot="option"
          slot-scope="prop"
        >
          {{ prop.option.content_type.name }}
        </span>
        <span
          slot="placeholder"
          class="multiselect__placeholder"
        >
          Select a content type
        </span>
      </multiselect>
    </div>

    <div
      class="form-group"
      v-if="(!$login.getUser().analyst || this.isAnEditor) && this.article.channel && analysts.length > 0"
    >
      <label>Primary Analyst</label>
      <multiselect
        :options="analysts"
        :allow-empty="false"
        :searchable="true"
        :show-labels="false"
        placeholder="Select an analyst"
        :class="{
          'is-invalid': highlightFields && article.analysts.length === 0
        }"
        label="name"
        track-by="id"
        :value="article.analyst"
        @input="setPrimaryAnalyst"
      >
        <span
          slot="placeholder"
          class="multiselect__placeholder"
        >
          Select an analyst
        </span>
      </multiselect>
    </div>

    <div class="form-group">
      <span class="label">Upload article PDF</span>
      <FileUpload
        action="?"
        :accept="['application/pdf']"
        :auto-upload="false"
        @filechange="onFileUpload"
        @input="pdfChanged"
        :value="article.pdf ? [{name: article.pdf}] : []"
        @preview="onPdfPreview"
      />
    </div>

    <div v-if="this.isAnEditor" class="form-group">
      <radio-selection :value="article.article_layout.id" @input="updateArticleLayoutId">
        <radio-option v-for="layout in layouts" :value="layout.id" :key="layout.id">
          <div class="text-left">
            {{ layout.name }}
          </div>
          <div class="py-5">
            <icon style="width: 8rem;height: 8rem;" :icon="layout.icon" />
          </div>
        </radio-option>
      </radio-selection>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

import {popup} from '@/helpers'
import {warningNotification} from '@/notifications'
import {FileUpload} from '@frontend/components'
import {RadioSelection, RadioOption} from '@frontend/components'

export default {
  name: 'TypeStep',

  components: {
    FileUpload,
    RadioSelection,
    RadioOption,
  },

  props: {
    article: {
      type: Object,
      required: true,
    },

    highlightFields: {
      type: Boolean,
      default: false,
    },

    analysts: {
      type: Array,
      required: true,
    },

    contentTypes: {
      type: Array,
      required: true,
    },

    layouts: {
      required: true,
      type: Array,
    },
  },

  data () {
    return {
      articleFiles: this.article.pdf ? [{name: this.article.pdf, url: this.article.pdf_url}] : [],
    }
  },

  computed: {
    ...mapGetters('channels', [
      'channels',
    ]),
    isAnEditor () {
      return this.$login.can('articles.update') && this.$login.can('article-drafts.publish')
    },
    contentType: {
      get () {

        return this.contentTypes.find(({id, content_type}) => id === this.article.channel_content_type.id && content_type)
      },
      set () {
        // this is done through emitters
      }
    },
  },

  methods: {
    setPrimaryAnalyst (analyst) {
      this.$emit('update', {analyst})

      if (!this.article.analysts.length) {
        const analysts = [analyst, ...this.article.analysts]
        this.$emit('update', {analysts})
      }
    },

    updateContentType (option, id) {
      this.$emit('update', {channel_content_type: option, channel_content_type_id: option.id})
      option.content_type.tags.forEach(tag => {
        this.$emit('add-tag', tag)
      })
    },

    updateArticleLayoutId (id) {
      this.$emit('update', {
        article_layout: this.layouts.find(l => l.id === id),
      })
    },


    onFileUpload (fileList) {
      const file = fileList[0]
      const reader = new FileReader()

      if (file.type !== 'application/pdf') {
        this.$notify(warningNotification('PDF files only!'))
        this.articleFiles = []
        return
      }

      reader.onload = (e) => {
        this.$emit('update', {
          upload_pdf: e.target.result,
          pdf_filename: file.name,
        })
        this.articleFiles = [{
          name: file.name,
        }]
      }

      reader.readAsDataURL(file)
    },

    pdfChanged (fileList) {
      console.log(fileList)
      if (fileList.length === 0) {
        this.removePdf()
      } else {
        this.article.pdf = fileList[0].name
      }
    },

    removePdf () {
      this.$emit('update', {pdf: null, upload_pdf: null, pdf_filename: null})
      this.articleFiles = []
    },

    async onPdfPreview () {
      let url
      if (this.article.article_draft_id) {
        url = `/articles/drafts/${this.article.article_draft_id}/admin-download`
      } else {
        url = `/articles/${this.article.id}/admin-download`
      }
      this.$http.get(url).then((r) => {
        popup(this, r.data.data.link)
      })
    },
  },
}
</script>

